import { Card } from 'semantic-ui-react';
import styles from '../components/styles/Activity.module.scss';
import { useFormContext } from 'react-hook-form';
import GridColumnInputWrapper from '@components/common/GridColumnInputWrapper';
import { useTranslation } from 'react-i18next';
import { useEffect, useRef } from 'react';
import TextArea from '@components/common/TextArea';

type Props = {
  header?: string;
  isTitle?: boolean;
  setTitle?: (title: string) => void;
  setText?: (text: string) => void;
  name: string;
  title?: string;
  text?: string;
  disabled?: boolean;
};

const ActivityText = ({
  header,
  isTitle,
  setTitle,
  setText,
  name,
  title,
  text,
  disabled,
}: Props) => {
  const {
    register,
    formState: { errors },
    setValue,
  } = useFormContext();

  const { t } = useTranslation();
  const fieldLength = isTitle ? 250 : 4000;

  const activityTextRegister = register(name, {
    required: t(`activity.form.error.${name}.required`),
    minLength: {
      value: 5,
      message: t('activity.form.error.field.min.val.5'),
    },
    maxLength: {
      value: fieldLength,
      message: t(`activity.form.error.field.max.val.${fieldLength}`),
    },
  });

  useEffect(() => {
    if (text) {
      setValue(name, text);
    }
    if (isTitle && title) {
      setValue(name, title);
    }
  }, []);

  return (
    <Card className={styles.cardText}>
      {header && <div className={styles.activityTextHeader}>{header}</div>}
      <div className={styles.inputWrapper}>
        <GridColumnInputWrapper
          value={isTitle ? title : text}
          rows={isTitle ? 1 : 3}
          render={(props: any) => (
            <>
              <div className={styles.errorMessage}>{errors[name]?.message?.toString()}</div>
              <TextArea
                register={activityTextRegister}
                disabled={disabled}
                value={isTitle ? title : text}
                rows={isTitle ? 1 : 3}
                onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
                  isTitle ? setTitle?.(e.target.value) : setText?.(e.target.value);
                  activityTextRegister.onChange(e);
                }}
                className={isTitle ? '' : styles.descriptionOverview}
              />
            </>
          )}
        />
      </div>
    </Card>
  );
};

export default ActivityText;
